import StepGuides from './StepGuides';

const 
  ADSL = 'adsl',
  VDSL = 'vdsl',
  EVDSL = 'evdsl';

const 
  RND_ADSL = 'ADSL',
  RND_VDSL = 'VDSL',
  RND_EVDSL = 'eVDSL';

export default function Box(props) {
  const 
    massima = parseInt(props.value.massima),
    stimata = parseInt(props.value.stimata),
    percent = parseInt((100*stimata)/massima),
    percentLoss = 100 - percent;

  const __nameMapper = (name) => {
    if (name === ADSL) { return RND_ADSL; }
    if (name === VDSL) { return RND_VDSL; }
    if (name === EVDSL) { return RND_EVDSL; }
  }

  const buildPills = (paramsList) => paramsList.map(buildPill)

  const buildPill = (params) => (
    <button 
      id = {params.id} 
      onClick = {params.handler} 
      className={`pill color${params.id}`}
    > {params.text} </button>
  )

  const showStepGuide = (serviceName) => ( 
    props.setResult(<StepGuides serviceName={
    buildPill({ id:serviceName, text:serviceName, handler:() => {} })  
    } />)
  )

  const __showPills = (maxSpeed, title) => {
    const pills = [];
    let advice = (
      <p>Non è disponibile fibra FTTC, puoi attivare: <br/> 
        { buildPill({ id: "ADSL", text:"ADSL2+", handler:() => { showStepGuide("ADSL") } }) }
      </p>
    );
    if (parseInt(maxSpeed) >= 30 && title !== EVDSL)  { 
      advice = <p> Puoi attivare i seguenti servizi Fibra: </p>
      pills.push({ id:'FTTC50', text:"FTTC 50", handler:()=>{showStepGuide('FTTC50')} })
    }
    if (parseInt(maxSpeed) >= 100 && title !== EVDSL) { 
      pills.push({ id:'FTTC100', text:"FTTC 100", handler:()=>{showStepGuide('FTTC100')} })
    }
    if (parseInt(maxSpeed) >= 200 && title === EVDSL) { 
      advice = <p> Puoi attivare i seguenti servizi Fibra: </p>
      pills.push({ id:'FTTC200', text:"FTTC 200", handler:()=>{showStepGuide('FTTC200')} })
    }
    return <div> { advice } { buildPills(pills) }  </div>;
  }

  return (
    <div 
      className = "services-item" 
      data-aos="fade-right" 
      style = { {
        "marginRight":"1%",
        "marginLeft":"1%",
      } }
    >
      <div className = "services-content">
        <div className = "icon centeredIcon"> 
          <img src='data:image/png;base64,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' /> 
        </div>
        <h1> {__nameMapper(props.title)} </h1>
        <hr />

        <p> Velocità massima: <b>{massima} Mbps </b> </p>
        <p> Velocità stimata: <b>{stimata} Mbps </b> </p>
        <p> Efficienza: <b>{percent}%  </b> </p>
        <p> Perdita: <b>{percentLoss}% </b> </p>

        <div className="w3-light-grey">
          <div 
            className="w3-container w3-blue w3-center" 
            style={{ width:`${percent}%` }}
          > {stimata} Mbps </div>
        </div>
        { __showPills(massima, props.title) } 
      </div>
    </div>
  );
}



